import RecordingsTemplate from './3da2f41b-fcb5-480d-ae6c-c24d1602895f.json';
import KidsTemplate from './48a85e10-091b-4d0b-975c-4a76074b2d29.json';
import OnDemandTemplate from './61536d25-6829-4956-b2ae-f20c51c749af.json';
import HomeTemplate from './a82cdd8c-d9c2-4502-b397-febf2d0ba0c2.json';
import SearchTemplate from './abf6ebc7-82de-4b96-83c0-7da3a6577743.json';

export default {
    '3da2f41b-fcb5-480d-ae6c-c24d1602895f': RecordingsTemplate,
    '48a85e10-091b-4d0b-975c-4a76074b2d29': KidsTemplate,
    '61536d25-6829-4956-b2ae-f20c51c749af': OnDemandTemplate,
    'a82cdd8c-d9c2-4502-b397-febf2d0ba0c2': HomeTemplate,
    'abf6ebc7-82de-4b96-83c0-7da3a6577743': SearchTemplate,
};
